import { render, staticRenderFns } from "./OCRExtract.vue?vue&type=template&id=bc41cef2&scoped=true"
import script from "./OCRExtract.vue?vue&type=script&lang=js"
export * from "./OCRExtract.vue?vue&type=script&lang=js"
import style0 from "./OCRExtract.vue?vue&type=style&index=0&id=bc41cef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc41cef2",
  null
  
)

export default component.exports